import { Theme, useMediaQuery } from '@mui/material';
import { CoreBox, CoreTypography } from '@youscience/core';
import { majorsDescriptionMap } from '@common-types';

import { getMajorDetailsPath } from '@constants/ROUTES';

import ChevronRight from '@images/chevron-right.svg?react';

import { sxStyles, StyledCardWrap, StyledTitlesWrap, StyledMajorTitle, StyledMoreBtn } from './AreaCard.styles';
import { StyledAreaIcon } from '@components/MajorCard/MajorCard.styles';
import { getMajorIconSrc } from '@utils/major';

interface AreaCardProps {
  cipCode: number;
}

export const AreaCard = (props: AreaCardProps) => {
  const { cipCode } = props;

  const isDesktopScreen = useMediaQuery((theme: Theme) => theme.breakpoints.up('sm'));

  const areaCipCode = Math.floor(cipCode);
  const areaImageSrc = getMajorIconSrc(areaCipCode);

  return (
    <StyledCardWrap>
      <CoreBox sx={sxStyles.flexPosition}>
        <StyledAreaIcon imageSrc={areaImageSrc} />

        <CoreBox sx={sxStyles.divider} />

        <StyledTitlesWrap>
          <StyledMajorTitle data-testid="majorTitle" variant="h5" component="h4">
            {majorsDescriptionMap.get(cipCode.toString())?.cipTitle}
          </StyledMajorTitle>

          <CoreTypography sx={sxStyles.cipCode}>{`CIP ${cipCode}`}</CoreTypography>
        </StyledTitlesWrap>
      </CoreBox>

      {isDesktopScreen ? (
        <CoreBox sx={sxStyles.flexPosition}>
          <CoreBox sx={sxStyles.divider} />

          <StyledMoreBtn to={getMajorDetailsPath(cipCode.toString())}>
            More
            <ChevronRight />
          </StyledMoreBtn>
        </CoreBox>
      ) : (
        <StyledMoreBtn to={getMajorDetailsPath(cipCode.toString())}>
          <ChevronRight />
        </StyledMoreBtn>
      )}
    </StyledCardWrap>
  );
};
